/** Leaflet + 2GIS — тот же стек, что в RadarGame / RadarPlayersMapScreen */
export const LOCATION_SCAN_MAP_HTML = `<!DOCTYPE html>
<html>
  <head>
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
    <link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css" />
    <script src="https://unpkg.com/leaflet@1.9.4/dist/leaflet.js"></script>
    <style>
      body, html { margin: 0; padding: 0; height: 100%; width: 100%; }
      #map { height: 100%; width: 100%; }
      .leaflet-control-zoom { display: none !important; }
      @keyframes hex-selected-pulse {
        0%, 100% { stroke-opacity: 1; fill-opacity: 0.32; }
        50% { stroke-opacity: 0.55; fill-opacity: 0.18; }
      }
      .hex-selected-pulse {
        animation: hex-selected-pulse 1.35s ease-in-out infinite;
      }
      .user-marker-container {
        position: relative;
        width: 42px;
        height: 42px;
        z-index: 1001 !important;
      }
      .user-marker-icon {
        width: 38px;
        height: 38px;
        object-fit: contain;
        border-radius: 50%;
        border: 2px solid #FACC15;
        background: rgba(10,10,20,0.82);
      }
      .user-marker-fallback {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        border: 2px solid #FACC15;
        background: rgba(250,204,21,0.18);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 800;
      }
      .other-player-marker-container {
        position: relative;
        width: 42px;
        height: 42px;
        z-index: 1000 !important;
      }
      .other-player-marker-icon {
        width: 38px;
        height: 38px;
        object-fit: contain;
        border-radius: 50%;
        border: 2px solid #38BDF8;
        background: rgba(10,10,20,0.82);
      }
      .other-player-marker-fallback {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        border: 2px solid #38BDF8;
        background: rgba(56,189,248,0.18);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 800;
      }
      .other-player-marker-wrap {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1px;
      }
      .other-player-marker-wrap.is-ghost {
        filter: grayscale(0.15);
      }
      .other-player-marker-wrap.is-ghost .other-player-marker-icon,
      .other-player-marker-wrap.is-ghost .other-player-marker-fallback {
        border-color: rgba(56, 189, 248, 0.55);
      }
      .marker-frame-ring,
      .marker-frame-halo {
        position: absolute;
        border-radius: 50%;
        pointer-events: none;
        display: none;
      }
      .profile-frame .marker-frame-ring {
        display: block;
        inset: -2px;
        border: 2px solid transparent;
      }
      .profile-frame-titan .marker-frame-ring {
        border-color: #FACC15;
      }
      .profile-frame-atlant .marker-frame-ring {
        border-color: #38BDF8;
      }
      .profile-frame-chest .marker-frame-ring {
        border-width: 2.5px;
      }
      .profile-frame-chest .marker-frame-halo {
        display: block;
        inset: -5px;
        border: 1.5px solid transparent;
        animation: profileFramePulse 2.8s ease-in-out infinite;
      }
      .profile-frame-chest.profile-frame-titan .marker-frame-halo {
        border-color: rgba(250,204,21,0.65);
      }
      .profile-frame-chest.profile-frame-atlant .marker-frame-halo {
        border-color: rgba(56,189,248,0.65);
      }
      @keyframes profileFramePulse {
        0%, 100% { opacity: 0.35; transform: scale(0.98); }
        50% { opacity: 0.95; transform: scale(1.06); }
      }
      .scan-point-pin {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        border: 3px solid #fff;
        box-shadow: 0 2px 8px rgba(0,0,0,0.35);
      }
      .scan-point-pin.active { background: #FACC15; }
      .scan-point-pin.inactive { background: #6B7280; }
      .scan-point-pin.league-titan.active { background: #FACC15; box-shadow: 0 0 0 2px #CA8A04; }
      .scan-point-pin.league-titan.inactive { background: #CA8A04; opacity: 0.55; }
      .scan-point-pin.league-atlant.active { background: #38BDF8; box-shadow: 0 0 0 2px #0284C7; }
      .scan-point-pin.league-atlant.inactive { background: #0284C7; opacity: 0.55; }
      .scan-point-pin.league-neutral.active { background: #9CA3AF; }
      .scan-point-pin.league-neutral.inactive { background: #6B7280; }
      .scan-point-pin.foreign { opacity: 0.7; }
      .scan-point-pin.boss.active { background: #EF4444; }
      .scan-point-pin.boss.inactive { background: #6B7280; }
      .scan-point-pin.cardshop.active { background: #A78BFA; }
      .scan-point-pin.cardshop.inactive { background: #6B7280; }
      .scan-point-pin.bank.active { background: #10B981; }
      .scan-point-pin.bank.inactive { background: #6B7280; }
      .scan-point-pin.cityhall.active { background: #F59E0B; }
      .scan-point-pin.cityhall.inactive { background: #6B7280; }
      .scan-point-pin.hotel.active { background: #38BDF8; }
      .scan-point-pin.hotel.inactive { background: #6B7280; }
      .scan-point-pin.wisetree.active { background: #86EFAC; }
      .scan-point-pin.wisetree.inactive { background: #6B7280; }
      .scan-point-pin.hangar.active { background: #A78BFA; }
      .scan-point-pin.hangar.inactive { background: #6B7280; }
      .scan-point-pin.treasure {
        width: 18px;
        height: 18px;
        margin-left: -2px;
        margin-top: -2px;
        box-shadow: 0 0 10px rgba(245, 158, 11, 0.85), 0 2px 8px rgba(0,0,0,0.35);
      }
      .scan-point-pin.treasure.active { background: #F59E0B; }
      .scan-point-pin.treasure.inactive {
        background: #92400E;
        opacity: 0.45;
        box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      }
      .map-point-icon-wrap {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        pointer-events: none;
      }
      .map-point-icon-wrap.labeled {
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
      }
      .map-point-icon {
        width: 28px;
        height: 28px;
        object-fit: contain;
        filter: drop-shadow(0 3px 8px rgba(0,0,0,0.45));
        transform-origin: center bottom;
      }
      .map-point-icon.inactive {
        opacity: 0.42;
        filter: grayscale(0.35) drop-shadow(0 2px 6px rgba(0,0,0,0.35));
      }
      .map-point-icon.foreign {
        opacity: 0.72;
      }
      .map-point-hp {
        margin-top: 2px;
        padding: 2px 6px;
        border-radius: 8px;
        background: rgba(12, 8, 24, 0.82);
        border: 1px solid rgba(192, 132, 252, 0.55);
        color: #F3E8FF;
        font: 700 10px/1.15 -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        white-space: nowrap;
        text-shadow: 0 1px 3px rgba(0,0,0,0.9);
        pointer-events: none;
      }
      .map-point-hp.inactive {
        opacity: 0.55;
        border-color: rgba(148, 163, 184, 0.4);
        color: #CBD5E1;
      }
      .city-map-label-wrap {
        background: transparent !important;
        border: none !important;
        z-index: 2500 !important;
      }
      .city-map-label {
        transform: translate(-50%, -50%);
        white-space: nowrap;
        font: 700 13px/1.2 -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        color: #f8fafc;
        text-shadow: 0 1px 4px rgba(0,0,0,0.9), 0 0 10px rgba(0,0,0,0.45);
        padding: 5px 10px;
        border-radius: 10px;
        background: rgba(10, 10, 20, 0.58);
        border: 1px solid rgba(255,255,255,0.14);
        pointer-events: none;
      }
      .city-map-label.own {
        color: #bbf7d0;
        border-color: rgba(74, 222, 128, 0.35);
        background: rgba(8, 28, 18, 0.68);
      }
    </style>
  </head>
  <body>
    <div id="map"></div>
    <script>
      (function() {
        const map = L.map('map', {
          preferCanvas: true,
          zoomControl: false,
          attributionControl: false
        }).setView([53.775911, 27.595015], 14);

        L.tileLayer('https://tile2.maps.2gis.com/tiles?x={x}&y={y}&z={z}&v=1', {
          maxZoom: 18,
          crossOrigin: true
        }).addTo(map);

        map.createPane('cityLabelPane');
        map.getPane('cityLabelPane').style.zIndex = 2500;
        map.getPane('cityLabelPane').style.pointerEvents = 'none';

        let userMarker = null;
        const pointLayers = {};
        const playerLayers = {};
        const airshipMissionLayers = {};
        const baseMarkerLayers = {};
        const cityPolygons = [];
        const cityLabels = [];
        let fogLayer = null;
        let hexLayer = null;
        let planeOverlay = null;
        let highlightCircle = null;
        let markerIconRegistry = null;
        let lastMapPoints = [];
        let lastOtherPlayers = [];
        let lastAirshipMissions = [];
        let lastBaseMarkers = [];
        let lastHexes = [];
        let lastSelectedHex = null;
        let lastMapPlane = 'SURFACE';
        let lastMapPosition = null;
        let lastPlayerNickname = 'Вы';
        let lastPlayerProfileFrameKey = null;
        let mapInitialized = false;
        let hasAutoFit = false;
        let viewportNotifyTimer = null;
        // Подписи городов — только на обзорном зуме (видно несколько городов)
        const CITY_LABEL_MAX_ZOOM = 11;
        const POINT_ICON_BASE_WRAP = 32;
        const POINT_ICON_BASE_IMG = 28;
        const POINT_ICON_CLOSE_ZOOM = 14;
        const POINT_ICON_CLOSE_SCALE = 2;
        /** Ниже — пустую сетку не рисуем; только own / player / selected / foreign tint. */
        const HEX_GRID_MIN_ZOOM = 14;
        /** Ниже — пустые гексы в шахматном порядке; с этого зума — все. */
        const HEX_GRID_FULL_ZOOM = 15.5;

        function postHostMessage(obj) {
          var s = JSON.stringify(obj);
          if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(s);
          }
          try {
            if (window.parent && window.parent !== window) {
              window.parent.postMessage(s, '*');
            }
          } catch (e) {}
        }

        // Покрытие региона карт (Беларусь + запас), вне городов — туман
        const FOG_WORLD_RING = [
          [51.0, 22.0],
          [51.0, 33.8],
          [57.0, 33.8],
          [57.0, 22.0]
        ];

        function postViewportBounds() {
          if (!mapInitialized) return;
          const bounds = map.getBounds();
          if (!bounds) return;
          postHostMessage({
            type: 'viewportChanged',
            minLat: bounds.getSouth(),
            minLng: bounds.getWest(),
            maxLat: bounds.getNorth(),
            maxLng: bounds.getEast(),
            zoom: map.getZoom()
          });
        }

        function scheduleViewportNotify() {
          if (viewportNotifyTimer) clearTimeout(viewportNotifyTimer);
          viewportNotifyTimer = setTimeout(function() {
            viewportNotifyTimer = null;
            postViewportBounds();
          }, 300);
        }

        map.whenReady(function() {
          setTimeout(function() {
            mapInitialized = true;
            map.on('zoomend', function() {
              syncCityLabelVisibility();
              refreshFeaturedPointIcons();
              if (lastHexes.length) updateHexes(lastHexes);
              scheduleViewportNotify();
            });
            map.on('moveend', function() {
              scheduleViewportNotify();
            });
            var mapReadyPayload = JSON.stringify({ type: 'mapReady' });
            if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(mapReadyPayload);
            }
            try {
              if (window.parent && window.parent !== window) {
                window.parent.postMessage(mapReadyPayload, '*');
              }
            } catch (e) {}
            postViewportBounds();
          }, 350);
        });

        function resolveProfileFrameClasses(profileFrameKey) {
          if (!profileFrameKey) return '';
          if (profileFrameKey === 'titan_frame') return 'profile-frame profile-frame-titan';
          if (profileFrameKey === 'atlant_frame') return 'profile-frame profile-frame-atlant';
          if (profileFrameKey === 'titan_chest_frame') return 'profile-frame profile-frame-titan profile-frame-chest';
          if (profileFrameKey === 'atlant_chest_frame') return 'profile-frame profile-frame-atlant profile-frame-chest';
          return '';
        }

        function buildMarkerFrameOverlay() {
          return '<div class="marker-frame-ring"></div><div class="marker-frame-halo"></div>';
        }

        function createUserMarkerIcon(iconUri, nickname, profileFrameKey) {
          const initial = escapeHtml((nickname || 'Вы').trim().charAt(0).toUpperCase() || 'В');
          const frameClass = resolveProfileFrameClasses(profileFrameKey);
          const containerClass = 'user-marker-container' + (frameClass ? ' ' + frameClass : '');
          const markerBody = iconUri
            ? '<img class="user-marker-icon" src="' + normalizeIconSrc(iconUri) + '" alt="" />'
            : '<div class="user-marker-fallback">' + initial + '</div>';
          const html =
            '<div class="other-player-marker-wrap">' +
              '<div class="' + containerClass + '">' +
                markerBody +
                buildMarkerFrameOverlay() +
              '</div>' +
            '</div>';
          return L.divIcon({
            html: html,
            iconSize: [42, 42],
            iconAnchor: [21, iconUri ? 38 : 21],
            className: 'custom-user-marker'
          });
        }

        function createUserMarker(lat, lng, iconUri, nickname, profileFrameKey) {
          return L.marker([lat, lng], {
            icon: createUserMarkerIcon(iconUri, nickname, profileFrameKey),
            zIndexOffset: 2000
          });
        }

        function attachUserMarkerClick(marker) {
          marker.off('click');
          marker.on('click', function(e) {
            L.DomEvent.stopPropagation(e);
            if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'selfPlayerPress'
              }));
            }
          });
        }

        function createOtherPlayerMarkerIcon(iconUri, nickname, profileFrameKey, opacity) {
          const initial = escapeHtml((nickname || '?').trim().charAt(0).toUpperCase() || '?');
          const frameClass = resolveProfileFrameClasses(profileFrameKey);
          const containerClass = 'other-player-marker-container' + (frameClass ? ' ' + frameClass : '');
          const markerBody = iconUri
            ? '<img class="other-player-marker-icon" src="' + normalizeIconSrc(iconUri) + '" alt="" />'
            : '<div class="other-player-marker-fallback">' + initial + '</div>';
          const opacityValue = Number.isFinite(opacity) ? Math.max(0.25, Math.min(1, opacity)) : 0.75;
          const html =
            '<div class="other-player-marker-wrap is-ghost" style="opacity:' + opacityValue + '">' +
              '<div class="' + containerClass + '">' +
                markerBody +
                buildMarkerFrameOverlay() +
              '</div>' +
            '</div>';
          return L.divIcon({
            html: html,
            iconSize: [42, 42],
            iconAnchor: [21, iconUri ? 38 : 21],
            className: 'custom-other-player-marker'
          });
        }

        function clearOtherPlayers() {
          Object.keys(playerLayers).forEach(function(markerId) {
            const entry = playerLayers[markerId];
            if (entry && entry.marker) map.removeLayer(entry.marker);
            delete playerLayers[markerId];
          });
        }

        function resolveOtherPlayerIcon(iconUri, affiliationElement, avatarVariant) {
          if (iconUri) return iconUri;
          if (!markerIconRegistry || !affiliationElement) return null;
          var variant = avatarVariant === 2 || avatarVariant === 3 ? avatarVariant : 1;
          var variantKey = affiliationElement + '-' + variant;
          if (markerIconRegistry.playerByElementVariant && markerIconRegistry.playerByElementVariant[variantKey]) {
            return markerIconRegistry.playerByElementVariant[variantKey];
          }
          if (markerIconRegistry.playerByElement && markerIconRegistry.playerByElement[affiliationElement]) {
            return markerIconRegistry.playerByElement[affiliationElement];
          }
          return markerIconRegistry.player || null;
        }

        function updateOtherPlayers(players) {
          const nextIds = {};
          (players || []).forEach(function(player) {
            if (!player || player.userId == null) return;
            if (!Number.isFinite(player.lat) || !Number.isFinite(player.lng)) return;
            const markerId = player.markerId != null
              ? String(player.markerId)
              : String(player.userId) + ':' + String(player.ageSec != null ? player.ageSec : 0);
            nextIds[markerId] = true;
            const latLng = [player.lat, player.lng];
            const iconUri = resolveOtherPlayerIcon(
              player.iconUri,
              player.affiliationElement,
              player.avatarVariant
            );
            const opacity = Number.isFinite(player.opacity) ? player.opacity : 0.75;
            const ageSec = Number.isFinite(player.ageSec) ? player.ageSec : null;
            const existing = playerLayers[markerId];
            if (existing && existing.marker) {
              existing.marker.setLatLng(latLng);
              existing.marker.setIcon(createOtherPlayerMarkerIcon(
                iconUri,
                player.nickname,
                player.profileFrameKey,
                opacity
              ));
              existing.userId = player.userId;
              existing.ageSec = ageSec;
              return;
            }
            const marker = L.marker(latLng, {
              icon: createOtherPlayerMarkerIcon(
                iconUri,
                player.nickname,
                player.profileFrameKey,
                opacity
              ),
              zIndexOffset: 1700 - Math.min(400, Math.round((ageSec || 0) / 3))
            }).addTo(map);
            marker.on('click', function(e) {
              L.DomEvent.stopPropagation(e);
              var payload = {
                type: 'playerPress',
                userId: player.userId
              };
              if (ageSec != null) payload.ageSec = ageSec;
              postHostMessage(payload);
            });
            playerLayers[markerId] = { marker: marker, userId: player.userId, ageSec: ageSec };
          });

          Object.keys(playerLayers).forEach(function(markerId) {
            if (!nextIds[markerId]) {
              const entry = playerLayers[markerId];
              if (entry && entry.marker) map.removeLayer(entry.marker);
              delete playerLayers[markerId];
            }
          });
        }

        function syncUserMarker(position, nickname, profileFrameKey) {
          if (!position) return;
          if (nickname) lastPlayerNickname = nickname;
          if (profileFrameKey !== undefined) lastPlayerProfileFrameKey = profileFrameKey;
          const iconUri = markerIconRegistry && markerIconRegistry.player ? markerIconRegistry.player : null;
          const latLng = [position.latitude, position.longitude];
          if (userMarker) {
            userMarker.setLatLng(latLng);
            userMarker.setIcon(createUserMarkerIcon(
              iconUri,
              lastPlayerNickname,
              lastPlayerProfileFrameKey
            ));
            return;
          }
          userMarker = createUserMarker(
            position.latitude,
            position.longitude,
            iconUri,
            lastPlayerNickname,
            lastPlayerProfileFrameKey
          ).addTo(map);
          attachUserMarkerClick(userMarker);
        }

        function escapeAttr(value) {
          return String(value || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;');
        }

        function escapeHtml(value) {
          return escapeAttr(value).replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }

        function normalizeIconSrc(value) {
          if (!value) return '';
          var src = String(value);
          if (src.indexOf('data:') === 0) return escapeAttr(src);
          if (src.indexOf('file://') === 0) return encodeURI(src);
          if (src.indexOf('./') === 0) return escapeAttr(src);
          if (src.indexOf('/') === 0) {
            if (window.ReactNativeWebView) {
              return encodeURI('file://' + src);
            }
            return encodeURI(src);
          }
          if (src.indexOf('http://') === 0 || src.indexOf('https://') === 0) return encodeURI(src);
          return escapeAttr('./' + src.replace(/^\\.\\//, ''));
        }

        function polygonCentroid(polygon) {
          if (!polygon || polygon.length === 0) return null;
          var sumLat = 0;
          var sumLng = 0;
          polygon.forEach(function(point) {
            sumLat += point.latitude;
            sumLng += point.longitude;
          });
          return {
            latitude: sumLat / polygon.length,
            longitude: sumLng / polygon.length
          };
        }

        function clearCityLabels() {
          cityLabels.forEach(function(marker) {
            map.removeLayer(marker);
          });
          cityLabels.length = 0;
        }

        function syncCityLabelVisibility() {
          var show = map.getZoom() <= CITY_LABEL_MAX_ZOOM;
          cityLabels.forEach(function(marker) {
            if (show) {
              if (!map.hasLayer(marker)) marker.addTo(map);
            } else if (map.hasLayer(marker)) {
              map.removeLayer(marker);
            }
          });
        }

        function updateCityLabels(items) {
          clearCityLabels();
          (items || []).forEach(function(item) {
            if (!item || !item.polygon || item.polygon.length < 3 || !item.title) return;
            var center = polygonCentroid(item.polygon);
            if (!center) return;
            var ownClass = item.isOwnCity ? ' own' : '';
            var icon = L.divIcon({
              html: '<div class="city-map-label' + ownClass + '">' + escapeHtml(item.title) + '</div>',
              className: 'city-map-label-wrap',
              iconSize: [0, 0],
              iconAnchor: [0, 0]
            });
            var marker = L.marker([center.latitude, center.longitude], {
              icon: icon,
              interactive: false,
              pane: 'cityLabelPane',
              zIndexOffset: 1000
            });
            cityLabels.push(marker);
          });
          syncCityLabelVisibility();
        }

        function resolveIconUri(iconRef, iconUri) {
          if (iconUri) return iconUri;
          if (!iconRef || !markerIconRegistry) return null;
          if (iconRef.kind === 'shop') return markerIconRegistry.shop || null;
          if (iconRef.kind === 'mail') return markerIconRegistry.mail || null;
          if (iconRef.kind === 'treasure') return markerIconRegistry.treasure || null;
          if (iconRef.kind === 'starfall') return markerIconRegistry.starfall || null;
          if (iconRef.kind === 'bank') return markerIconRegistry.bank || null;
          if (iconRef.kind === 'cityhall') return markerIconRegistry.cityhall || null;
          if (iconRef.kind === 'hotel') return markerIconRegistry.hotel || null;
          if (iconRef.kind === 'wisetree') return markerIconRegistry.wisetree || null;
          if (iconRef.kind === 'hangar') return markerIconRegistry.hangar || null;
          if (iconRef.kind === 'worldboss') return markerIconRegistry.worldboss || null;
          if (iconRef.kind === 'scan') {
            const byLeague = markerIconRegistry.scanByLeague || {};
            const league = iconRef.league || 'NEUTRAL';
            return byLeague[league] || byLeague.NEUTRAL || null;
          }
          const list = markerIconRegistry[iconRef.kind];
          if (!Array.isArray(list) || list.length === 0) return null;
          return list[iconRef.index] || list[0] || null;
        }

        function getFeaturedPointIconScale(kind) {
          if (
            kind !== 'boss' &&
            kind !== 'worldboss' &&
            kind !== 'cardshop' &&
            kind !== 'boostershop' &&
            kind !== 'postoffice' &&
            kind !== 'scan' &&
            kind !== 'treasure' &&
            kind !== 'bank' &&
            kind !== 'cityhall' &&
            kind !== 'hotel' &&
            kind !== 'wisetree' &&
            kind !== 'hangar'
          ) return 1;
          if (kind === 'worldboss') {
            return map.getZoom() >= POINT_ICON_CLOSE_ZOOM ? 2.4 : 1.35;
          }
          return map.getZoom() >= POINT_ICON_CLOSE_ZOOM ? POINT_ICON_CLOSE_SCALE : 1;
        }

        function refreshFeaturedPointIcons() {
          Object.keys(pointLayers).forEach(function(id) {
            const entry = pointLayers[id];
            if (!entry || !entry.meta || !entry.marker) return;
            const point = entry.meta;
            if (
              point.kind !== 'boss' &&
              point.kind !== 'worldboss' &&
              point.kind !== 'cardshop' &&
              point.kind !== 'boostershop' &&
              point.kind !== 'postoffice' &&
              point.kind !== 'scan' &&
              point.kind !== 'treasure' &&
              point.kind !== 'bank' &&
              point.kind !== 'cityhall' &&
              point.kind !== 'hotel' &&
              point.kind !== 'hangar'
            ) return;
            entry.marker.setIcon(createPointPin(
              !!point.isAvailable,
              point.kind,
              point.dominantLeague || 'NEUTRAL',
              point.isOwnCity !== false,
              point.iconRef,
              point.iconUri,
              point.label || null
            ));
          });
        }

        function createPointPin(isAvailable, kind, dominantLeague, isOwnCity, iconRef, iconUri, label) {
          const scanSizeScale = kind === 'scan' ? 0.5 : 1;
          const resolvedIconUri = resolveIconUri(iconRef, iconUri);
          if (resolvedIconUri) {
            const scale = getFeaturedPointIconScale(kind);
            const wrapW = POINT_ICON_BASE_WRAP * scale * scanSizeScale;
            const imgSize = POINT_ICON_BASE_IMG * scale * scanSizeScale;
            const hasLabel = !!(label && String(label).trim());
            const labelText = hasLabel ? String(label).trim() : '';
            const labelH = hasLabel ? 16 : 0;
            const wrapWidth = hasLabel
              ? Math.max(wrapW, Math.min(168, 10 + labelText.length * 6.4))
              : wrapW;
            const wrapH = wrapW + labelH;
            const anchorX = Math.round(wrapWidth / 2);
            const anchorY = Math.round(imgSize);
            const foreignClass = kind === 'scan' && isOwnCity === false ? ' foreign' : '';
            const stateClass = isAvailable ? 'active' : 'inactive';
            const wrapClass = 'map-point-icon-wrap' + (hasLabel ? ' labeled' : '');
            const wrapStyle = 'width:' + wrapWidth + 'px;height:' + wrapH + 'px';
            const imgStyle = 'width:' + imgSize + 'px;height:' + imgSize + 'px';
            const labelHtml = hasLabel
              ? '<div class="map-point-hp ' + stateClass + '">' + escapeHtml(labelText) + '</div>'
              : '';
            return L.divIcon({
              html: '<div class="' + wrapClass + '" style="' + wrapStyle + '"><img class="map-point-icon ' + stateClass + foreignClass + '" style="' + imgStyle + '" src="' + normalizeIconSrc(resolvedIconUri) + '" alt="" />' + labelHtml + '</div>',
              iconSize: [wrapWidth, wrapH],
              iconAnchor: [anchorX, anchorY],
              className: 'map-point-image-marker'
            });
          }

          const bossClass = kind === 'boss' || kind === 'worldboss' ? ' boss' : '';
          const cardshopClass = kind === 'cardshop' ? ' cardshop' : '';
          const bankClass = kind === 'bank' ? ' bank' : '';
          const cityHallClass = kind === 'cityhall' ? ' cityhall' : '';
          const hotelClass = kind === 'hotel' ? ' hotel' : '';
          const wiseTreeClass = kind === 'wisetree' ? ' wisetree' : '';
          const hangarClass = kind === 'hangar' ? ' hangar' : '';
          const treasureClass = kind === 'treasure' ? ' treasure' : '';
          const foreignClass = kind === 'scan' && isOwnCity === false ? ' foreign' : '';
          let leagueClass = '';
          if (kind === 'scan' && dominantLeague) {
            if (dominantLeague === 'TITAN') leagueClass = ' league-titan';
            else if (dominantLeague === 'ATLANT') leagueClass = ' league-atlant';
            else leagueClass = ' league-neutral';
          }
          const pinSize = kind === 'treasure' ? 18 : kind === 'scan' ? 7 : 14;
          const pinAnchor = Math.round(pinSize / 2);
          const pinStyle = kind === 'scan' ? ' style="width:7px;height:7px;border-width:1.5px;"' : '';
          return L.divIcon({
            html: '<div class="scan-point-pin' + bossClass + cardshopClass + bankClass + cityHallClass + hotelClass + wiseTreeClass + hangarClass + treasureClass + leagueClass + foreignClass + ' ' + (isAvailable ? 'active' : 'inactive') + '"' + pinStyle + '></div>',
            iconSize: [pinSize, pinSize],
            iconAnchor: [pinAnchor, pinAnchor],
            className: 'scan-point-marker'
          });
        }

        function clearCityPolygons() {
          cityPolygons.forEach(function(layer) {
            map.removeLayer(layer);
          });
          cityPolygons.length = 0;
        }

        function clearFogLayer() {
          if (fogLayer) {
            map.removeLayer(fogLayer);
            fogLayer = null;
          }
        }

        function collectCityRings(items) {
          const rings = [];
          (items || []).forEach(function(item) {
            if (!item || !item.polygon || item.polygon.length < 3) return;
            const ring = item.polygon.map(function(p) {
              return [p.latitude, p.longitude];
            });
            // Дырки в полигоне — обратное направление внешнего кольца
            rings.push(ring.slice().reverse());
          });
          return rings;
        }

        function updateFogLayer(items) {
          clearFogLayer();
          const holes = collectCityRings(items);
          if (holes.length === 0) return;

          fogLayer = L.polygon([FOG_WORLD_RING].concat(holes), {
            fillColor: '#0b1220',
            fillOpacity: 0.78,
            color: 'rgba(148,163,184,0.12)',
            weight: 1,
            interactive: false,
            smoothFactor: 0.8
          }).addTo(map);
        }

        function resolveCityPolygonStyle(isOwn, dominantLeague) {
          if (dominantLeague === 'TITAN') {
            return {
              color: isOwn ? '#CA8A04' : 'rgba(202,138,4,0.55)',
              fillColor: '#FACC15',
              fillOpacity: isOwn ? 0.32 : 0.07,
              weight: isOwn ? 3 : 2
            };
          }
          if (dominantLeague === 'ATLANT') {
            return {
              color: isOwn ? '#0284C7' : 'rgba(2,132,199,0.55)',
              fillColor: '#38BDF8',
              fillOpacity: isOwn ? 0.32 : 0.07,
              weight: isOwn ? 3 : 2
            };
          }
          if (dominantLeague === 'NEUTRAL') {
            return {
              color: isOwn ? '#6B7280' : '#9E9E9E',
              fillColor: '#9CA3AF',
              fillOpacity: isOwn ? 0.1 : 0.04,
              weight: isOwn ? 3 : 2
            };
          }
          return {
            color: isOwn ? '#4CAF50' : '#9E9E9E',
            fillColor: isOwn ? '#4CAF50' : '#9E9E9E',
            fillOpacity: isOwn ? 0.08 : 0.03,
            weight: isOwn ? 3 : 2
          };
        }

        function updateCityPolygons(items) {
          clearCityPolygons();
          updateFogLayer(items);
          updateCityLabels(items);
          (items || []).forEach(function(item) {
            if (!item || !item.polygon || item.polygon.length < 3) return;
            const coords = item.polygon.map(function(p) {
              return [p.latitude, p.longitude];
            });
            const isOwn = !!item.isOwnCity;
            const style = resolveCityPolygonStyle(isOwn, item.dominantLeague);
            const layer = L.polygon(coords, {
              color: style.color,
              fillColor: style.fillColor,
              fillOpacity: style.fillOpacity,
              weight: style.weight,
              interactive: false
            }).addTo(map);
            cityPolygons.push(layer);
          });
        }

        function updateLegacyCityPolygon(polygon) {
          if (!polygon || polygon.length < 3) return;
          clearCityPolygons();
          updateFogLayer([{ polygon: polygon }]);
          const coords = polygon.map(function(p) {
            return [p.latitude, p.longitude];
          });
          const layer = L.polygon(coords, {
            color: 'rgba(38,174,255,0.85)',
            fillColor: 'rgba(38,174,255,0.18)',
            fillOpacity: 0.18,
            weight: 3,
            interactive: false
          }).addTo(map);
          cityPolygons.push(layer);
        }

        function clearPoints() {
          Object.keys(pointLayers).forEach(function(id) {
            const entry = pointLayers[id];
            if (entry.marker) map.removeLayer(entry.marker);
            if (entry.circle) map.removeLayer(entry.circle);
            delete pointLayers[id];
          });
        }

        function updatePoints(points) {
          clearPoints();
          (points || []).forEach(function(point) {
            if (!Number.isFinite(point.lat) || !Number.isFinite(point.lng)) return;
            const latLng = [point.lat, point.lng];
            const active = !!point.isAvailable;
            const isBoss = point.kind === 'boss';
            const isWorldBoss = point.kind === 'worldboss';
            const isCardShop = point.kind === 'cardshop';
            const isBoosterShop = point.kind === 'boostershop';
            const isPostOffice = point.kind === 'postoffice';
            const isTreasure = point.kind === 'treasure';
            const isBank = point.kind === 'bank';
            const isCityHall = point.kind === 'cityhall';
            const isHotel = point.kind === 'hotel';
            const isWiseTree = point.kind === 'wisetree';
            const isHangar = point.kind === 'hangar';
            const isOwnCity = point.isOwnCity !== false;
            const dominantLeague = point.dominantLeague || 'NEUTRAL';
            const foreignOpacity =
              !isBoss && !isWorldBoss && !isCardShop && !isBoosterShop && !isPostOffice && !isTreasure && !isBank && !isCityHall && !isHotel && !isWiseTree && !isHangar && !isOwnCity ? 0.7 : 1;
            const hasCustomIcon =
              point.kind !== 'scan' &&
              !!resolveIconUri(point.iconRef, point.iconUri);
            let stroke = active ? '#FACC15' : '#6B7280';
            if (!isBoss && !isWorldBoss && !isCardShop && !isBoosterShop && !isPostOffice && !isTreasure && !isBank && !isCityHall && !isHotel && !isWiseTree && !isHangar) {
              if (dominantLeague === 'TITAN') stroke = active ? '#FACC15' : '#CA8A04';
              else if (dominantLeague === 'ATLANT') stroke = active ? '#38BDF8' : '#0284C7';
              else stroke = active ? '#9CA3AF' : '#6B7280';
            } else if (isWorldBoss) {
              stroke = active ? '#C084FC' : '#6B7280';
            } else if (isBoss) {
              stroke = active ? '#EF4444' : '#6B7280';
            } else if (isCardShop) {
              stroke = active ? '#A78BFA' : '#6B7280';
            } else if (isBoosterShop) {
              stroke = active ? '#FBBF24' : '#6B7280';
            } else if (isPostOffice) {
              stroke = active ? '#38BDF8' : '#6B7280';
            } else if (isTreasure) {
              stroke = active ? '#F59E0B' : '#92400E';
            } else if (isBank) {
              stroke = active ? '#10B981' : '#6B7280';
            } else if (isCityHall) {
              stroke = active ? '#F59E0B' : '#6B7280';
            } else if (isHotel) {
              stroke = active ? '#38BDF8' : '#6B7280';
            } else if (isWiseTree) {
              stroke = active ? '#86EFAC' : '#6B7280';
            } else if (isHangar) {
              stroke = active ? '#A78BFA' : '#6B7280';
            }
            const circle =
              hasCustomIcon || point.kind === 'scan' || point.kind === 'treasure'
                ? null
                : L.circle(latLng, {
              radius: point.radiusM || 50,
              color: stroke,
              fillColor: stroke,
              fillOpacity: active ? 0.12 : 0.08,
              opacity: (active ? 0.85 : 0.7) * foreignOpacity,
              weight: 2,
              interactive: false
            }).addTo(map);
            const marker = L.marker(latLng, {
              icon: createPointPin(active, point.kind, dominantLeague, isOwnCity, point.iconRef, point.iconUri, point.label || null),
              zIndexOffset: isWorldBoss ? 1900 : isTreasure && active ? 1700 : active ? 1500 : 1200
            }).addTo(map);
            marker.on('click', function(e) {
              L.DomEvent.stopPropagation(e);
              postHostMessage({ type: 'pointPress', pointId: point.id });
            });
            pointLayers[point.id] = { marker: marker, circle: circle, meta: point };
          });
        }

        function resolvePointStroke(point, active) {
          const isBoss = point.kind === 'boss';
          const isWorldBoss = point.kind === 'worldboss';
          const isCardShop = point.kind === 'cardshop';
          const isBoosterShop = point.kind === 'boostershop';
          const isPostOffice = point.kind === 'postoffice';
          const isTreasure = point.kind === 'treasure';
          const isBank = point.kind === 'bank';
          const isCityHall = point.kind === 'cityhall';
          const isHotel = point.kind === 'hotel';
            const isWiseTree = point.kind === 'wisetree';
          const isHangar = point.kind === 'hangar';
          const dominantLeague = point.dominantLeague || 'NEUTRAL';
          if (!isBoss && !isWorldBoss && !isCardShop && !isBoosterShop && !isPostOffice && !isTreasure && !isBank && !isCityHall && !isHotel && !isWiseTree && !isHangar) {
            if (dominantLeague === 'TITAN') return active ? '#FACC15' : '#CA8A04';
            if (dominantLeague === 'ATLANT') return active ? '#38BDF8' : '#0284C7';
            return active ? '#9CA3AF' : '#6B7280';
          }
          if (isWorldBoss) return active ? '#C084FC' : '#6B7280';
          if (isBoss) return active ? '#EF4444' : '#6B7280';
          if (isCardShop) return active ? '#A78BFA' : '#6B7280';
          if (isBoosterShop) return active ? '#FBBF24' : '#6B7280';
          if (isPostOffice) return active ? '#38BDF8' : '#6B7280';
          if (isTreasure) return active ? '#F59E0B' : '#92400E';
          if (isBank) return active ? '#10B981' : '#6B7280';
          if (isCityHall) return active ? '#F59E0B' : '#6B7280';
          if (isHotel) return active ? '#38BDF8' : '#6B7280';
          if (isWiseTree) return active ? '#86EFAC' : '#6B7280';
          if (isHangar) return active ? '#A78BFA' : '#6B7280';
          return active ? '#FACC15' : '#6B7280';
        }

        function clearAirshipMissions() {
          Object.keys(airshipMissionLayers).forEach(function(id) {
            const entry = airshipMissionLayers[id];
            if (entry.line) map.removeLayer(entry.line);
            if (entry.marker) map.removeLayer(entry.marker);
            delete airshipMissionLayers[id];
          });
        }

        function lerpAirshipPos(mission) {
          if (mission.currentPos && Number.isFinite(mission.currentPos.lat) && Number.isFinite(mission.currentPos.lng)) {
            return [mission.currentPos.lat, mission.currentPos.lng];
          }
          if (!mission.route || !mission.route.from || !mission.route.to) return null;
          const from = mission.route.from;
          const to = mission.route.to;
          const departed = mission.departedAt ? Date.parse(mission.departedAt) : NaN;
          const arrive = mission.arriveAt ? Date.parse(mission.arriveAt) : NaN;
          const ret = mission.returnAt ? Date.parse(mission.returnAt) : NaN;
          const now = Date.now();
          function mix(a, b, t) {
            return [a.lat + (b.lat - a.lat) * t, a.lng + (b.lng - a.lng) * t];
          }
          if (mission.status === 'IN_FLIGHT' && Number.isFinite(departed) && Number.isFinite(arrive) && arrive > departed) {
            const t = Math.max(0, Math.min(1, (now - departed) / (arrive - departed)));
            return mix(from, to, t);
          }
          if (mission.status === 'RETURNING' && Number.isFinite(arrive) && Number.isFinite(ret) && ret > arrive) {
            const t = Math.max(0, Math.min(1, (now - arrive) / (ret - arrive)));
            return mix(to, from, t);
          }
          return mission.status === 'RETURNING' ? [from.lat, from.lng] : [to.lat, to.lng];
        }

        function createAirshipMarkerIcon(isOwn) {
          const uri = markerIconRegistry && markerIconRegistry.airship
            ? markerIconRegistry.airship
            : null;
          if (uri) {
            return L.divIcon({
              html: '<div style="width:40px;height:40px;background:transparent;display:flex;align-items:center;justify-content:center;"><img src="' + normalizeIconSrc(uri) + '" style="width:40px;height:40px;object-fit:contain;filter:drop-shadow(0 1px 3px rgba(0,0,0,0.55));" alt=""/></div>',
              iconSize: [40, 40],
              iconAnchor: [20, 20],
              className: 'airship-mission-marker'
            });
          }
          return L.divIcon({
            html: '<div style="width:10px;height:10px;border-radius:50%;background:' + (isOwn ? '#FACC15' : '#94A3B8') + ';box-shadow:0 1px 4px rgba(0,0,0,0.4);"></div>',
            iconSize: [10, 10],
            iconAnchor: [5, 5],
            className: 'airship-mission-marker'
          });
        }

        function updateAirshipMissions(missions) {
          clearAirshipMissions();
          (missions || []).forEach(function(mission) {
            if (!mission || !mission.id || !mission.route || !mission.route.from || !mission.route.to) return;
            const from = mission.route.from;
            const to = mission.route.to;
            if (!Number.isFinite(from.lat) || !Number.isFinite(from.lng) || !Number.isFinite(to.lat) || !Number.isFinite(to.lng)) return;
            const isOwn = !!mission.isOwn;
            const line = L.polyline([[from.lat, from.lng], [to.lat, to.lng]], {
              color: isOwn ? '#FACC15' : 'rgba(148,163,184,0.75)',
              weight: isOwn ? 3.5 : 2,
              opacity: isOwn ? 0.95 : 0.55,
              dashArray: isOwn ? null : '8 8',
              interactive: false
            }).addTo(map);
            const pos = lerpAirshipPos(mission);
            let marker = null;
            if (pos) {
              marker = L.marker(pos, {
                icon: createAirshipMarkerIcon(isOwn),
                zIndexOffset: isOwn ? 2500 : 2000,
                interactive: true
              }).addTo(map);
              marker.on('click', function(e) {
                L.DomEvent.stopPropagation(e);
                if (window.ReactNativeWebView) {
                  window.ReactNativeWebView.postMessage(JSON.stringify({
                    type: 'airshipMissionPress',
                    missionId: mission.id
                  }));
                }
              });
              if (mission.ownerNickname) {
                marker.bindTooltip(mission.ownerNickname, {
                  direction: 'top',
                  offset: [0, -12],
                  opacity: 0.9
                });
              }
            }
            airshipMissionLayers[mission.id] = { line: line, marker: marker };
          });
        }

        function clearHexLayer() {
          if (hexLayer) {
            map.removeLayer(hexLayer);
            hexLayer = null;
          }
        }

        function hexPalette(plane) {
          if (plane === 'UNDERWORLD') {
            return {
              emptyStroke: '#F59E0B',
              emptyOpacity: 0.28,
              foreignStroke: '#A8A29E',
              foreignFill: '#78350F',
              own: '#FACC15',
              player: '#FDBA74',
              selected: '#FB923C'
            };
          }
          if (plane === 'HEAVEN') {
            return {
              emptyStroke: '#67E8F9',
              emptyOpacity: 0.34,
              foreignStroke: '#94A3B8',
              foreignFill: '#0E7490',
              own: '#FDE68A',
              player: '#38BDF8',
              selected: '#22D3EE'
            };
          }
          return {
            emptyStroke: '#9CA3AF',
            emptyOpacity: 0.25,
            foreignStroke: '#6B7280',
            foreignFill: '#4B5563',
            own: '#FACC15',
            player: '#D1D5DB',
            selected: '#E5E7EB'
          };
        }

        function pointInPolygon(lat, lng, polygon) {
          if (!polygon || polygon.length < 3) return false;
          let inside = false;
          for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
            const yi = polygon[i].lat;
            const xi = polygon[i].lng;
            const yj = polygon[j].lat;
            const xj = polygon[j].lng;
            const intersect =
              (yi > lat) !== (yj > lat) &&
              lng < ((xj - xi) * (lat - yi)) / ((yj - yi) || 1e-12) + xi;
            if (intersect) inside = !inside;
          }
          return inside;
        }

        function findPlayerHexKey(hexes, position) {
          if (!position || !hexes || !hexes.length) return null;
          const lat = position.latitude;
          const lng = position.longitude;
          if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
          for (let i = 0; i < hexes.length; i++) {
            const h = hexes[i];
            if (h && pointInPolygon(lat, lng, h.polygon)) {
              return h.q + ':' + h.r;
            }
          }
          let best = null;
          let bestDist = Infinity;
          for (let i = 0; i < hexes.length; i++) {
            const h = hexes[i];
            if (!h || !h.center) continue;
            const dLat = h.center.lat - lat;
            const dLng = h.center.lng - lng;
            const d = dLat * dLat + dLng * dLng;
            if (d < bestDist) {
              bestDist = d;
              best = h;
            }
          }
          if (!best || bestDist > 0.000012) return null;
          return best.q + ':' + best.r;
        }

        function shouldDrawEmptyHex(q, r, zoom) {
          if (zoom < HEX_GRID_MIN_ZOOM) return false;
          if (zoom < HEX_GRID_FULL_ZOOM) {
            return ((q + r) & 1) === 0;
          }
          return true;
        }

        function updateHexes(hexes) {
          clearHexLayer();
          lastHexes = hexes || [];
          if (!lastHexes.length) return;
          if (lastMapPlane !== 'UNDERWORLD' && lastMapPlane !== 'HEAVEN') return;

          const zoom = map.getZoom();
          const palette = hexPalette(lastMapPlane);
          const playerKey = findPlayerHexKey(lastHexes, lastMapPosition);
          const selectedKey = lastSelectedHex
            ? lastSelectedHex.q + ':' + lastSelectedHex.r
            : null;

          hexLayer = L.layerGroup();
          lastHexes.forEach(function(h) {
            if (!h || !Array.isArray(h.polygon) || h.polygon.length < 3) return;
            const key = h.q + ':' + h.r;
            const isOwn = !!h.isOwn;
            const isForeign = !!h.occupied && !isOwn;
            const isPlayer = playerKey != null && key === playerKey;
            const isSelected = selectedKey != null && key === selectedKey;

            if (!isOwn && !isForeign && !isPlayer && !isSelected) {
              if (!shouldDrawEmptyHex(h.q, h.r, zoom)) return;
            }

            let color = palette.emptyStroke;
            let fillColor = palette.emptyStroke;
            let fillOpacity = 0;
            let weight = 0.7;
            let opacity = palette.emptyOpacity;
            let dashArray = null;
            let className = '';
            let interactive = true;

            if (isForeign && !isOwn && !isSelected && !isPlayer) {
              color = palette.foreignStroke;
              fillColor = palette.foreignFill;
              fillOpacity = 0.08;
              weight = 0.6;
              opacity = 0.28;
            }
            if (isPlayer && !isOwn) {
              color = palette.player;
              fillColor = palette.player;
              fillOpacity = 0.14;
              weight = 2;
              opacity = 0.9;
              dashArray = '5 4';
            }
            if (isOwn) {
              color = palette.own;
              fillColor = palette.own;
              fillOpacity = 0.28;
              weight = 2.4;
              opacity = 0.95;
              dashArray = null;
            }
            if (isSelected) {
              color = palette.selected;
              fillColor = palette.selected;
              fillOpacity = 0.3;
              weight = 2.8;
              opacity = 1;
              dashArray = null;
              className = 'hex-selected-pulse';
            }

            const latlngs = h.polygon.map(function(p) {
              return [p.lat, p.lng];
            });
            const poly = L.polygon(latlngs, {
              color: color,
              fillColor: fillColor,
              fillOpacity: fillOpacity,
              weight: weight,
              opacity: opacity,
              dashArray: dashArray || undefined,
              className: className || undefined,
              interactive: interactive
            });
            poly.on('click', function(e) {
              L.DomEvent.stopPropagation(e);
              postHostMessage({
                type: 'hexPress',
                q: h.q,
                r: h.r,
                occupied: !!h.occupied,
                baseId: h.baseId || null,
                isOwn: !!h.isOwn,
                center: h.center || null
              });
            });
            hexLayer.addLayer(poly);
          });
          hexLayer.addTo(map);
        }

        function setSelectedHex(hex) {
          if (
            hex &&
            Number.isFinite(hex.q) &&
            Number.isFinite(hex.r)
          ) {
            lastSelectedHex = { q: hex.q, r: hex.r };
          } else {
            lastSelectedHex = null;
          }
          if (lastHexes.length) updateHexes(lastHexes);
        }

        function clearBaseMarkers() {
          Object.keys(baseMarkerLayers).forEach(function(id) {
            const marker = baseMarkerLayers[id];
            if (marker) map.removeLayer(marker);
            delete baseMarkerLayers[id];
          });
        }

        function baseMarkerColor(league, fullness) {
          if (league === 'TITAN') {
            if (fullness === 'HIGH') return '#FACC15';
            if (fullness === 'LOW') return '#CA8A04';
            return '#854D0E';
          }
          if (league === 'ATLANT') {
            if (fullness === 'HIGH') return '#38BDF8';
            if (fullness === 'LOW') return '#0284C7';
            return '#0C4A6E';
          }
          if (fullness === 'HIGH') return '#A3A3A3';
          if (fullness === 'LOW') return '#737373';
          return '#525252';
        }

        function createBaseMarkerIcon(base) {
          const league = (base.league || '').toUpperCase();
          const uri =
            league === 'ATLANT'
              ? (markerIconRegistry && markerIconRegistry.baseAtlant)
              : (markerIconRegistry && markerIconRegistry.baseTitan);
          const size = 68;
          const shield = base.hasShield
            ? '<div style="position:absolute;top:0;right:0;width:14px;height:14px;border-radius:50%;background:#67E8F9;border:1.5px solid #fff;box-shadow:0 0 5px rgba(103,232,249,0.95);"></div>'
            : '';
          if (uri) {
            const html =
              '<div style="position:relative;width:' + size + 'px;height:' + size + 'px;">' +
                '<img src="' + normalizeIconSrc(uri) + '" style="width:' + size + 'px;height:' + size + 'px;object-fit:contain;filter:drop-shadow(0 2px 5px rgba(0,0,0,0.55));" alt=""/>' +
                shield +
              '</div>';
            return L.divIcon({
              html: html,
              iconSize: [size, size],
              iconAnchor: [size / 2, size - 6],
              className: 'base-map-marker'
            });
          }
          const color = baseMarkerColor(base.league, base.stockFullness);
          const fallback = 36;
          const html =
            '<div style="position:relative;width:' + fallback + 'px;height:' + fallback + 'px;">' +
              '<div style="width:' + fallback + 'px;height:' + fallback + 'px;border-radius:8px;transform:rotate(45deg);background:' + color + ';border:2px solid rgba(255,255,255,0.85);box-shadow:0 2px 6px rgba(0,0,0,0.45);"></div>' +
              shield +
            '</div>';
          return L.divIcon({
            html: html,
            iconSize: [fallback, fallback],
            iconAnchor: [fallback / 2, fallback / 2],
            className: 'base-map-marker'
          });
        }

        function updateBaseMarkers(bases) {
          clearBaseMarkers();
          lastBaseMarkers = bases || [];
          lastBaseMarkers.forEach(function(base) {
            if (!base || !base.id || !base.center) return;
            if (!Number.isFinite(base.center.lat) || !Number.isFinite(base.center.lng)) return;
            const marker = L.marker([base.center.lat, base.center.lng], {
              icon: createBaseMarkerIcon(base),
              zIndexOffset: 1800,
              interactive: true
            }).addTo(map);
            marker.on('click', function(e) {
              L.DomEvent.stopPropagation(e);
              postHostMessage({ type: 'basePress', baseId: base.id });
            });
            if (base.nickname) {
              marker.bindTooltip(base.nickname, {
                direction: 'top',
                offset: [0, -18],
                opacity: 0.9
              });
            }
            baseMarkerLayers[base.id] = marker;
          });
        }

        function updateMapPlane(plane) {
          lastMapPlane = plane || 'SURFACE';
          const tilePane = map.getPane('tilePane');
          if (tilePane) {
            if (lastMapPlane === 'UNDERWORLD') {
              tilePane.style.filter = 'grayscale(0.35) brightness(0.55) contrast(1.15) sepia(0.35)';
            } else if (lastMapPlane === 'HEAVEN') {
              tilePane.style.filter = 'brightness(1.18) saturate(0.85) hue-rotate(195deg) contrast(0.95)';
            } else {
              tilePane.style.filter = '';
            }
          }
          if (planeOverlay) {
            map.removeLayer(planeOverlay);
            planeOverlay = null;
          }
          if (lastMapPlane === 'UNDERWORLD' || lastMapPlane === 'HEAVEN') {
            const color = lastMapPlane === 'UNDERWORLD'
              ? 'rgba(28, 16, 8, 0.28)'
              : 'rgba(180, 220, 255, 0.18)';
            planeOverlay = L.rectangle([[-90, -180], [90, 180]], {
              color: 'transparent',
              fillColor: color,
              fillOpacity: 1,
              interactive: false,
              pane: 'overlayPane'
            }).addTo(map);
          }
          if (lastHexes.length) updateHexes(lastHexes);
        }

        function clearHighlightCircle() {
          if (highlightCircle) {
            map.removeLayer(highlightCircle);
            highlightCircle = null;
          }
        }

        function updateHighlightPoint(pointId, points) {
          clearHighlightCircle();
          if (!pointId) return;
          const point = (points || []).find(function(item) {
            return item && item.id === pointId;
          });
          if (!point || !Number.isFinite(point.lat) || !Number.isFinite(point.lng)) return;
          const active = !!point.isAvailable;
          const stroke = resolvePointStroke(point, active);
          highlightCircle = L.circle([point.lat, point.lng], {
            radius: point.radiusM || 50,
            color: stroke,
            fillColor: stroke,
            fillOpacity: 0.1,
            opacity: 0.95,
            weight: 2.5,
            dashArray: '7 6',
            interactive: false
          }).addTo(map);
        }

        function fitMapView(position, points, force) {
          if (!force) return;

          const ownCityPolygon = cityPolygons.find(function(layer, index) {
            return layer.options && layer.options.weight === 3;
          });
          if (ownCityPolygon) {
            map.fitBounds(ownCityPolygon.getBounds().pad(0.05), { maxZoom: 14, animate: false });
            hasAutoFit = true;
            return;
          }
          const ownScanPoints = (points || []).filter(function(point) {
            return point.kind === 'scan' && point.isOwnCity !== false;
          });
          if (ownScanPoints.length > 0) {
            const ownBounds = L.latLngBounds(ownScanPoints.map(function(point) {
              return [point.lat, point.lng];
            }));
            map.fitBounds(ownBounds.pad(0.12), { maxZoom: 16, animate: false });
            hasAutoFit = true;
            return;
          }

          const layers = [];
          if (userMarker) layers.push(userMarker);
          Object.keys(pointLayers).forEach(function(id) {
            layers.push(pointLayers[id].marker);
          });
          cityPolygons.forEach(function(layer) {
            layers.push(layer);
          });

          if (layers.length > 1) {
            map.fitBounds(L.featureGroup(layers).getBounds().pad(0.12), { maxZoom: 16, animate: false });
            hasAutoFit = true;
            return;
          }
          if (layers.length === 1) {
            if (cityPolygons.length > 0 && cityPolygons.indexOf(layers[0]) >= 0) {
              map.fitBounds(layers[0].getBounds().pad(0.05), { maxZoom: 14, animate: false });
            } else {
              map.setView(layers[0].getLatLng(), 15, { animate: false });
            }
            hasAutoFit = true;
            return;
          }
          if (position) {
            map.setView([position.latitude, position.longitude], 15, { animate: false });
            hasAutoFit = true;
          }
        }

        function parseHostMessage(raw) {
          if (typeof raw === 'string') return JSON.parse(raw);
          if (raw && typeof raw === 'object') return raw;
          return null;
        }

        function handleMessage(event) {
          try {
            const data = parseHostMessage(event.data);
            if (!data || !mapInitialized) return;

            if (data.type === 'setMarkerIcons') {
              markerIconRegistry = data.icons || null;
              if (lastMapPoints.length > 0) {
                updatePoints(lastMapPoints);
              }
              if (lastOtherPlayers.length > 0) {
                updateOtherPlayers(lastOtherPlayers);
              }
              if (lastAirshipMissions.length > 0) {
                updateAirshipMissions(lastAirshipMissions);
              }
              if (lastBaseMarkers.length > 0) {
                updateBaseMarkers(lastBaseMarkers);
              }
              if (lastMapPosition) {
                syncUserMarker(
                  lastMapPosition,
                  lastPlayerNickname,
                  lastPlayerProfileFrameKey
                );
              }
              return;
            }

            if (data.type === 'update') {
              if (data.icons) {
                markerIconRegistry = data.icons;
              }
              if (data.position) {
                lastMapPosition = data.position;
                syncUserMarker(
                  data.position,
                  data.playerNickname,
                  data.playerProfileFrameKey
                );
                if (lastHexes.length) updateHexes(lastHexes);
              }
              if (data.playerNickname) {
                lastPlayerNickname = data.playerNickname;
              }
              if (data.playerProfileFrameKey !== undefined) {
                lastPlayerProfileFrameKey = data.playerProfileFrameKey;
              }
              if (Array.isArray(data.cityPolygons)) {
                updateCityPolygons(data.cityPolygons);
              } else if (Array.isArray(data.polygon)) {
                updateLegacyCityPolygon(data.polygon);
              }
              if (data.center && data.autoFit === true && (!data.points || data.points.length === 0)) {
                map.setView([data.center.latitude, data.center.longitude], 13, { animate: false });
                hasAutoFit = true;
              }
              updatePoints(data.points || []);
              lastMapPoints = data.points || [];
              lastOtherPlayers = data.otherPlayers || [];
              updateOtherPlayers(lastOtherPlayers);
              lastAirshipMissions = data.airshipMissions || [];
              updateAirshipMissions(lastAirshipMissions);
              if (data.highlightPointId !== undefined) {
                updateHighlightPoint(data.highlightPointId, lastMapPoints);
              }
              fitMapView(data.position, data.points, data.autoFit === true);
              syncCityLabelVisibility();
            }

            if (data.type === 'setAirshipMissions') {
              lastAirshipMissions = data.missions || [];
              updateAirshipMissions(lastAirshipMissions);
            }

            if (data.type === 'setHexes') {
              updateHexes(data.hexes || []);
            }

            if (data.type === 'setSelectedHex') {
              setSelectedHex(data.hex || null);
            }

            if (data.type === 'setBaseMarkers') {
              updateBaseMarkers(data.bases || []);
            }

            if (data.type === 'setMapPlane') {
              updateMapPlane(data.plane || 'SURFACE');
            }

            if (data.type === 'setHighlight') {
              updateHighlightPoint(data.pointId || null, lastMapPoints);
            }

            if (data.type === 'centerOnSelf' && data.position) {
              map.setView([data.position.latitude, data.position.longitude], 16, { animate: true });
            }
          } catch (e) {}
        }

        window.addEventListener('message', handleMessage);
        document.addEventListener('message', function(event) {
          window.dispatchEvent(new MessageEvent('message', { data: event.data }));
        });
      })();
    </script>
  </body>
</html>`
